import { NgModule } from '@angular/core';
import { MuiSkeletonShapeComponent } from './mui-skeleton-shape/mui-skeleton-shape.component';
import { MuiSkeletonTextComponent } from './mui-skeleton-text/mui-skeleton-text.component';


@NgModule({
  imports: [
    MuiSkeletonTextComponent,
    MuiSkeletonShapeComponent
  ],
  exports: [
    MuiSkeletonTextComponent,
    MuiSkeletonShapeComponent
  ]
})
export class MuiSkeletonModule {}
